module.exports = __webpack_public_path__ + "img/3화_5(3).4f508ebb.png";